import Image from 'app/Components/Shared/Image/image';
import React, {useRef} from 'react';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import {getSessionId} from '../../../utilities/userStorageAPI/localStorageAPI';
import ProviderManager from '../../../provider/providerManager';
import addImage from './images/plus.svg';
import removeImage from './images/x.svg';

const ExtendedLeadFilesUpload = (props) => {
  const fileInputRef = useRef();

  function handleFileStartLoading() {
    props.onFileStartLoading();
  }

  function handleFileFinishLoading() {
    props.onFileFinishLoading();
  }

  async function startUploadingFile(e, supportedFileExtensions) {
    if (e.target.files.length == 0) {
      return;
    }

    const file = e.target.files[0];
    fileInputRef.current.value = '';
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isSupported =
      supportedFileExtensions
        .split(',')
        .map((x) => x.replace('.', ''))
        .indexOf(fileExtension) > -1;
    if (!isSupported) {
      return;
    }

    let convertedBase64File = await toBase64(file);
    convertedBase64File = convertedBase64File.replace(`data:${file.type};base64,`, '');

    try {
      handleFileStartLoading();
      const token = await getRecaptchaToken('fileUpload');
      await uploadFile(file.name, fileExtension, convertedBase64File, token);
    } catch (ex) {
    } finally {
      handleFileFinishLoading();
    }
  }

  async function uploadFile(name, extension, converted, token) {
    const consumerId = getSessionId();
    const uploadFileResult = await ProviderManager.getProviderData('uploadFileForValidation', [extension, converted, token, consumerId]);
    if (uploadFileResult?.Header?.ReturnCode == 0) {
      props.onFileAdded({
        localName: name,
        storageName: uploadFileResult?.Body?.fileName,
      });
    }
  }

  async function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  function handleAddClick(e) {
    fileInputRef.current.click();
  }

  async function handleFileInputChange(e) {
    await startUploadingFile(e, props.supportedFileExtensions);
  }

  function handleRemoveClick(fileName) {
    props.onFileRemoved(fileName);
  }

  return (
    <div className='files-upload-wrapper'>
      {props.files.map((item) => (
        <div key={item.localName} className='file-item' onClick={() => handleRemoveClick(item.localName)}>
          <Image src={removeImage} alt='הסר קובץ' />
          <span className='remove-file-text'>{item.localName}</span>
        </div>
      ))}

      {props.files.length < props.maxFilesToUpload && (
        <div className='file-item' onClick={handleAddClick}>
          <Image src={addImage} alt='הוסף קובץ' />
          <span className='add-file-text'>הוסף קובץ</span>
          <input
            ref={fileInputRef}
            style={{height: 0, width: 0, overflow: 'hidden'}}
            className=''
            type='file'
            name='fileUpload'
            accept={props.supportedFileExtensions}
            id='file-upload-input'
            onChange={handleFileInputChange}
          />
        </div>
      )}

      {props.additionalText && <div dangerouslySetInnerHTML={{__html: props.additionalText}}></div>}
    </div>
  );
};

export default ExtendedLeadFilesUpload;
